import React from "react";

const DeleteMyAccount = () => {
  return <div>dddddbds</div>;
};

export default DeleteMyAccount;
